<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 15:47:15
 * @LastEditTime: 2020-06-14 11:00:10
 * @Description: 试题筛选步骤
 -->
<template>
  <div class="test-question-filter-by-product-group">
    <i-tree :data="data" expand-node />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'TestQuestionFilterByProductGroup',
  props: {
    filterMenu: { type: Object, required: true },
  },
  data() {
    return {
      data: [
        {
          title: '年份',
          expand: true,
          children: [],
        },
        {
          title: '难易度',
          expand: true,
          children: [],
        },
        {
          title: '所属题库',
          expand: true,
          children: [],
        },
      ],
      yearsFilter: [],
      levelsFilter: [],
      typesFilter: [],
    };
  },
  computed: {
    ...mapGetters({
      addBigQuestionRule: 'createPaperStore/addBigQuestionRule',
    }),
  },
  watch: {
    filterMenu(menu) {
      this.settingTreeData(menu);
    },
    yearsFilter(values) {
      this.setAddBigQuestionRuleOfYears({ years: values });
    },
    levelsFilter(values) {
      this.setAddBigQuestionRuleOfLevels({ levels: values });
    },
    typesFilter(values) {
      this.setAddBigQuestionRuleOfLibraryTypes({ libraryTypes: values });
    },
  },
  methods: {
    ...mapActions({
      setAddBigQuestionRuleOfYears: 'createPaperStore/invokeSetAddBigQuestionRuleOfYears',
      setAddBigQuestionRuleOfLevels: 'createPaperStore/invokeSetAddBigQuestionRuleOfLevels',
      setAddBigQuestionRuleOfLibraryTypes: 'createPaperStore/invokeSetAddBigQuestionRuleOfLibraryTypes',
    }),
    /**
     * 设置目录树data
     */
    settingTreeData({ years, libraryTypes, levels }) {
      const yearsChildren = [];
      const levelsChildren = [];
      const typesChildren = [];

      // 年份
      yearsChildren.push({
        expand: false,
        type: 'year',
        render: (h) => {
          const yearsCheckbox = [];

          years.forEach((year) => {
            yearsCheckbox.push(h('i-checkbox', {
              props: {
                label: year,
              },
            }));
          });

          return h('div', {}, [h('i-checkbox-group', {
            props: {
              value: this.yearsFilter,
            },
            on: {
              'on-change': this.selectFiltersCheckbox({ type: 'year' }),
            },
          }, yearsCheckbox)]);
        },
      });

      // 困难度
      levelsChildren.push({
        expand: false,
        type: 'level',
        render: (h) => {
          const levelsCheckbox = [];

          levels.forEach((level) => {
            levelsCheckbox.push(h('i-checkbox', {
              props: {
                label: level,
              },
            }));
          });

          return h('div', {}, [h('i-checkbox-group', {
            props: {
              value: this.levelsFilter,
            },
            on: {
              'on-change': this.selectFiltersCheckbox({ type: 'level' }),
            },
          }, levelsCheckbox)]);
        },
      });

      // 所属型号
      typesChildren.push({
        expand: false,
        type: 'type',
        render: (h) => {
          const typesCheckbox = [];

          libraryTypes.forEach((type) => {
            typesCheckbox.push(h('i-checkbox', {
              props: {
                label: type,
              },
            }));
          });

          return h('div', {}, [h('i-checkbox-group', {
            props: {
              value: this.typesFilter,
            },
            on: {
              'on-change': this.selectFiltersCheckbox({ type: 'type' }),
            },
          }, typesCheckbox)]);
        },
      });

      this.data[0].children = yearsChildren;
      this.data[1].children = levelsChildren;
      this.data[2].children = typesChildren;
    },
    /**
     * 选择筛选条件复选框数据绑定
     */
    selectFiltersCheckbox({ type }) {
      return (values) => {
        if (type === 'year') {
          this.yearsFilter = values;
        } else if (type === 'level') {
          this.levelsFilter = values;
        } else if (type === 'type') {
          this.typesFilter = values;
        }
      };
    },
    /**
     * 请求产品型号并设置
     */
    // requestProductListAndSetting() {
    //   this.requestProductList()
    //     .then((result) => {
    //       this.models = result;
    //     })
    //     .catch(() => {
    //     });
    // },
    /**
     * 请求产品型号
     */
    // requestProductList() {
    //   const params = {
    //     paperId: this.addBigQuestionRule.paperId,
    //     questionType: this.addBigQuestionRule.questionType,
    //     years: this.yearsFilter.join(','),
    //     level: this.levelsFilter.join(','),
    //   };

    //   return new Promise(async (resolve, reject) => {
    //     const result = await this.$http.examcenter.paperCreateProductList(params);

    //     if (result.code === '200') {
    //       resolve(result.data);
    //     } else {
    //       reject(result);
    //     }
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
.test-question-filter-by-product-group {
  width: 50%;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #ddd;

  /deep/ .ivu-tree {
    .ivu-tree-title:hover,
    .ivu-tree-title-selected,
    .ivu-tree-title-selected:hover {
      background-color: transparent;
    }

    .ivu-tree-children .ivu-tree-arrow {
      width: 0;
    }

    > .ivu-tree-children > li > .ivu-tree-arrow {
      width: 12px;
    }

    .ivu-checkbox-group {
      display: flex;
      flex-direction: column;

      > .ivu-checkbox-group-item {
        margin-bottom: 6px;

        &:last-of-type {
          margin-bottom: 0;
        }

        > span:last-of-type {
          margin-left: 6px;
        }
      }

      > .ivu-select {
        margin-bottom: 6px;
      }
    }
  }

  /deep/ .ivu-select-dropdown {
    padding: 0;

    .ivu-select-dropdown-list {
      padding: 4px 8px;

      .ivu-select-item {
        margin: 0;
        padding: 3px 0;
        font-size: 13px !important;
      }

      .ivu-select-item-focus,
      .ivu-select-item-selected:hover {
        background-color: transparent;
      }

      .ivu-select-item-selected::after {
        font-size: 16px;
      }
    }
  }

  /deep/ .exclusive-model {
    width: 280px;

    > .ivu-select-selection > div {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>
